export default function WarningBlock({ children }) {
  return (
    <div className="border-l-4 border-rose bg-whisper text-haiti px-6 py-px rounded">
      {children}
    </div>
  );
}
